// invest_FE/src/components/modals/InquiryMessageModal.js
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './InquiryMessageModal.css';

const InquiryMessageModal = ({ isOpen, onClose, onSend, isLoading, onEditPreferences }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const defaultMessage = t('inquiryMessageModal.defaultMessage');

  useEffect(() => {
    // Set default message when modal opens
    if (isOpen) {
      setMessage(defaultMessage);
      setAgreedToTerms(false);
    }
  }, [isOpen, defaultMessage]);

  const handleSend = (e) => {
    e.preventDefault();
    if (!message.trim() || !agreedToTerms) {
      return;
    }
    onSend(message);
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="inquiry-message-modal-overlay">
      <div className="inquiry-message-modal-content">
        <button className="close-btn" onClick={onClose} aria-label={t('inquiryMessageModal.closeAriaLabel')}>
          <i className="fas fa-times"></i>
        </button>
        <h2>{t('inquiryMessageModal.title')}</h2>
        <p className="intro-text">{t('inquiryMessageModal.introText')}</p>
        <form onSubmit={handleSend}>
          <div className="form-group">
            <label htmlFor="inquiryMessage">{t('inquiryMessageModal.messageLabel')}</label>
            <textarea id="inquiryMessage" name="inquiryMessage" rows="6" placeholder={t('inquiryMessageModal.messagePlaceholder')} value={message} onChange={(e) => setMessage(e.target.value)} required disabled={isLoading} />
          </div>
          <div className="disclosure-section">
            <p className="disclosure-note">{t('inquiryMessageModal.disclosureNote')}</p>
            <div className="agreement-checkbox">
              <input type="checkbox" id="agreeToShare" checked={agreedToTerms} onChange={(e) => setAgreedToTerms(e.target.checked)} disabled={isLoading} />
              <label htmlFor="agreeToShare">{t('inquiryMessageModal.agreementLabel')}</label>
            </div>
          </div>
          <div className="button-group">
            <button type="submit" className="send-btn" disabled={isLoading || !message.trim() || !agreedToTerms}>
              {isLoading ? t('inquiryMessageModal.sendingButton') : t('inquiryMessageModal.sendButton')}
            </button>
            <button type="button" className="cancel-btn" onClick={onClose} disabled={isLoading}>
              {t('inquiryMessageModal.cancelButton')}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default InquiryMessageModal;
